import { Permission } from '@act/shared/authorization';
import { ActingUserDto, UserDto } from '@act/shared/data-transfer-objects';

// Permission checking utilities
export const checkPermissionOnMember = ({
  member,
  actingUser,
  permission,
}: {
  member: UserDto;
  actingUser: ActingUserDto;
  permission: Permission;
}): boolean => {
  const combinedPermissions = [
    ...(actingUser?.userPermissions || []),
    ...(member?.memberPermissions || []),
  ];
  return combinedPermissions.includes(permission);
};

export const checkPermissionOnUser = ({
  actingUser,
  permission,
}: {
  actingUser: ActingUserDto;
  permission: Permission;
}): boolean => {
  if (!actingUser || !actingUser.userPermissions) {
    return false;
  }

  return actingUser.userPermissions.includes(permission);
};
